import type { IconData } from '@stacksjs/iconify-core'

export const steps1Flat: IconData = {
  "body": "<g fill=\"#8fbffa\"><path fill-rule=\"evenodd\" d=\"M27 24a2 2 0 0 1 2-2h6a2 2 0 1 1 0 4h-6a2 2 0 0 1-2-2m-16 0a2 2 0 0 1 2-2h6a2 2 0 1 1 0 4h-6a2 2 0 0 1-2-2\" clip-rule=\"evenodd\"/><path d=\"M8 17.5a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13m16 0a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13m16 0a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default steps1Flat
